const columns = [
    { name: 'created_at', label: 'Criado em', field: 'created_at', align: 'center', sortable: true },
    { name: 'nome', label: 'Nome', field: 'nome', align: 'center', sortable: true },
    { name: 'sobrenome',  label: 'Sobrenome', field: 'sobrenome', align: 'center', sortable: true },
    { name: 'email', label: 'Email', field: 'email', align: 'center', sortable: true },
    { name: 'role_id', label: 'Cargo', field: row => row.role.nome, align: 'center', sortable: true },
    { name: 'action', label: 'Action', field: 'action', align: 'center', }
]

export default columns